import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=71520be0&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=71520be0&lang=scss&scoped=true&"
import style1 from "./aboutUs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71520be0",
  null
  
)

export default component.exports